import React from "react";
import ctl from "@netlify/classnames-template-literals";
import ArrowRight from "svgs/arrow-right.svg";
import { Container, Text } from "components";

const PageFeatures = ({ features, image }) => {
  return (
    <Container>
      <div className={sectionWrapperStyle}>
        <ul className="max-w-[650px]">
          {features.map((feature, index) => (
            <li key={`pageFeatures_${index}`} className={listStyle}>
              <span className="mr-[13px]">
                <ArrowRight />
              </span>
              <Text value={feature} variant="h3" color="secondary-1200" />
            </li>
          ))}
        </ul>
        <div className="max-w-[510px]">{image}</div>
      </div>
    </Container>
  );
};

const sectionWrapperStyle = ctl(`
flex
 flex-col 
 lg:flex-row 
 justify-between 
 pt-[71px] 
 lg:pt-[104px]
  pb-[210px]
`);
const listStyle = ctl(`
mb-[72px]
 flex
`);
export { PageFeatures };
